import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

// Section heading with an optional colored accent bar, eyebrow, and trailing slot.
const SectionHeader = ({ eyebrow, title, subtitle, accent, align = 'left', action, className }) => (
  <div
    className={cx(
      'mb-6',
      align === 'center' && 'text-center mx-auto max-w-2xl',
      className
    )}
  >
    <div className={cx('flex items-end justify-between gap-4', align === 'center' && 'flex-col items-center')}>
      <div className={cx(align === 'center' && 'flex flex-col items-center')}>
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-widest text-brand-600 mb-1.5">
            {eyebrow}
          </p>
        )}
        <div className="flex items-center gap-3">
          {accent && align !== 'center' && (
            <span className="block w-1.5 h-6 rounded-full" style={{ backgroundColor: accent }} />
          )}
          <h2 className="text-2xl sm:text-3xl font-bold font-display text-ink-900">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-ink-500">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  </div>
);

export default SectionHeader;
